<template>
    <div class="animated fade-in" v-if="!loading">

        <div v-if="mutable_contact">
            <div class="border-left pl-2 mb-4">
<!--                <h6 class="my-4">Contact Information</h6>-->
                <form-row label="First Name">
                    <template v-slot:field><c-input type="text" v-model="mutable_contact.first_name" placeholder="First Name" title="First Name"></c-input></template>
                </form-row>
                <form-row label="Last Name">
                    <template v-slot:field><c-input type="text" v-model="mutable_contact.last_name" placeholder="Last Name" title="Last Name"></c-input></template>
                </form-row>
                <form-row label="Phone">
                    <template v-slot:field><c-input type="text" v-model="mutable_contact.phone" placeholder="Phone" title="Phone"></c-input></template>
                </form-row>
                <form-row label="Mobile">
                    <template v-slot:field><c-input type="text" v-model="mutable_contact.mobile" placeholder="Mobile" title="Mobile"></c-input></template>
                </form-row>
                <!-- <form-row label="Fax">
                    <template v-slot:field><c-input type="text" v-model="mutable_contact.fax" placeholder="Fax" title="Fax"></c-input></template>
                </form-row> -->
                <form-row label="Email" v-if="!mutable_user">
                    <template v-slot:field><c-input type="text" v-model="mutable_contact.email" placeholder="Email" title="Email"></c-input></template>
                </form-row>
                <!--            <c-input type="text" v-model="mutable_contact.facebook" placeholder="Facebook" title="Facebook"></c-input>-->
                <!--            <c-input type="text" v-model="mutable_contact.twitter" placeholder="Twitter" title="Twitter"></c-input>-->
                <!--            <c-input type="text" v-model="mutable_contact.website" placeholder="Website" title="Website"></c-input>-->
            </div>
            <div class="border-left pl-2 mb-4" v-if="mutable_user">
                <form-row label="Notification Preference">
                    <template v-slot:field>
                        <c-select
                            type="text"
                            :value="mutable_user.notification_preference"
                            :options="notification_options"
                            @update:value="(value) => mutable_user.notification_preference = value.key"
                        ></c-select></template>
                </form-row>
            </div>
        </div>
        <div v-if="!mutable_contact">
            <b-alert show>No contact was provided.</b-alert>
        </div>

    </div>
</template>

<script>
  import ToastNotifications from "../../../components/shared/mixins/ToastNotifications";
  import CustomerContact from "../../../models/CustomerContact";
  import FormRow from "../../shared/FormRow";

  export default {
    name: 'CustomerContactForm',
    components: {FormRow},
    props: ['customer_contact_id', 'contact', 'user'],
    mixins: [ToastNotifications],
    data () {
      return {
        loading: true,
        mutable_contact: null,
        mutable_user: null,
        notification_options: [
          {key: null, label: '- Select -'},
          {key: 'mail', label: 'Email'},
          {key: 'sms', label: 'SMS'},
          {key: 'both', label: 'Both'}
        ]
      }
    },
    methods: {
      init() {
        this.loading = true;
        if(this.contact) {
          this.mutable_contact = this.contact;
          if(this.user) {
            this.mutable_user = this.user;
          }
          this.loading = false;
        } else if(this.customer_contact_id) {
          CustomerContact.api().retrieve(this.customer_contact_id).then((results) => {
            this.mutable_contact = results.entities.contacts[0];
            this.mutable_user = results.entities.users[0];
            this.loading = false;
          });
        } else {
          this.loading = false;
        }
      }
    },
    watch: {
      mutable_contact: function(contact) {
        this.$emit('onContactChange', contact);
      },
      mutable_user: function(user) {
        this.$emit('onUserChange', user);
      }
    },
    created() {
      this.init();
    }
  }
</script>
